(function () {
  'use strict';
  /* The app-proxy prefix is a ROUTE, not copy — but it is stored in a text setting, and
     Translate & Adapt rewrites text settings. On /ar it arrived as "/تطبيقات/سيف", so every
     availability call went to a URL that does not exist, every one 404'd, and the Arabic site
     could not book a session at all: pick a date, get "could not check availability", stop.
     A storefront route is ASCII by construction, so anything else is damage, not configuration. */
  function proxyBase() {
    var p = String((state.config && state.config.proxyPath) || '');
    if (!/^\/[A-Za-z0-9\-_./]*$/.test(p)) p = '/apps/saif';
    return p.replace(/\/$/, '');
  }
  /* ---- i18n ------------------------------------------------------------------
     Steps 2-4 are drawn here, not in Liquid, so every string below comes from the
     saif.booking keys the bridge exposes. Month and weekday names are the one
     exception: no translation file should own data the browser already carries for
     every locale, so they come from Intl in the document's own language. */
  function bt(key, fallback, vars) {
    var b = (window.SaifI18n && window.SaifI18n.booking) || {};
    var s = b[key] || fallback;
    if (vars) for (var k in vars) s = s.split('{' + k + '}').join(vars[k]);
    return s;
  }
  var DOC_LANG = (document.documentElement.getAttribute('lang') || 'en');
  var EN_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];
  var EN_MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var EN_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function intlNames(opts, fallback, build) {
    try {
      var f = new Intl.DateTimeFormat(DOC_LANG, opts);
      var out = [];
      for (var i = 0; i < fallback.length; i++) out.push(f.format(build(i)));
      return out;
    } catch (e) { return fallback; }
  }
  var MONTHS = intlNames({ month: 'long' }, EN_MONTHS, function (i) { return new Date(2021, i, 1); });
  var MONTHS_SHORT = intlNames({ month: 'short' }, EN_MONTHS_SHORT, function (i) { return new Date(2021, i, 1); });
  // 2021-08-01 was a Sunday, so index 0..6 walks Sun..Sat.
  var DAYS = intlNames({ weekday: 'short' }, EN_DAYS, function (i) { return new Date(2021, 7, 1 + i); });

  /* ============================================
     STATE
     ============================================ */
  var state = {
    currentStep: 1,
    selectedService: null,
    selectedDate: null,
    selectedSlot: null,
    selectedSessions: [],
    currentMonth: null,
    availabilityCache: {},
    prefetching: {},
    config: null
  };

  var els = {};

  /* ============================================
     INIT
     ============================================ */
  function init() {
    var configEl = document.querySelector('[id^="SaifBookingConfig-"]');
    if (!configEl) return;

    try {
      state.config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    /* Step 1's view never fires from goToStep: currentStep starts at 1 and goToStep only runs
       on next/prev, so the wizard's ENTRY — the denominator for every drop-off below it — was
       missing. Fired here instead, once the config parses, which is the moment the wizard is
       actually usable. */
    if (window.SaifTrack) {
      window.SaifTrack('booking_step_viewed', { step: 1, from_step: 0, service: null,
        logged_in: !!state.loggedIn, entry: true });
    }

    var sid = state.config.sectionId;
    els = {
      progress: document.getElementById('SaifBookingProgress-' + sid),
      steps: document.querySelectorAll('[data-booking-step]'),
      error: document.getElementById('SaifBookingError-' + sid),
      serviceSummary: document.getElementById('SaifBookingServiceSummary-' + sid),
      calendar: document.getElementById('SaifBookingCalendar-' + sid),
      slots: document.getElementById('SaifBookingSlots-' + sid),
      sessions: document.getElementById('SaifBookingSessions-' + sid),
      sessionsCounter: document.getElementById('SaifBookingSessionsCounter-' + sid),
      sessionsList: document.getElementById('SaifBookingSessionsList-' + sid),
      form: document.getElementById('SaifBookingForm-' + sid),
      summary: document.getElementById('SaifBookingSummary-' + sid),
      backBtn: document.getElementById('SaifBookingBackBtn-' + sid),
      nextBtn: document.getElementById('SaifBookingNextBtn-' + sid),
      nav: document.getElementById('SaifBookingNav-' + sid),
      overlay: document.getElementById('SaifBookingOverlay-' + sid)
    };

    state.currentMonth = getMinBookingDate();
    state.loggedIn = state.config.loggedIn || false;

    bindServiceCards();
    bindNavButtons();

    // With exactly one service there is no real choice to make:
    // pre-select it on load so the card shows its confirmed state and
    // Continue is live at full contrast immediately. `silent` keeps the
    // programmatic selection out of the analytics funnel.
    if (state.config.services.length === 1) {
      selectService(state.config.services[0].id, { silent: true });
    }
    updateNavLayout(state.currentStep);
  }

  /* ============================================
     STEP MANAGEMENT
     ============================================ */
  function goToStep(n) {
    /* SAIF_BOOKING_TRACK_V1 (2026-08-03) — the booking wizard sells the site's most expensive
       items ($120 and $480) through four steps, and carried exactly two events: one when a
       service was picked and one when the whole thing was submitted. Everything between was
       invisible, so "people start booking and don't finish" could never be located to a step.
       This mirrors the hero quiz, which is instrumented per step and is the reason we know
       its email wall costs 30%.

       Fired on ARRIVAL at a step, and only when the step actually changes — goToStep is also
       called to re-render the current step, which would otherwise double-count. */
    if (n !== state.currentStep && window.SaifTrack) {
      window.SaifTrack('booking_step_viewed', {
        step: n,
        from_step: state.currentStep || 0,
        service: (state.selectedService && state.selectedService.name) || null,
        logged_in: !!state.loggedIn
      });
    }
    state.currentStep = n;

    els.steps.forEach(function (step) {
      var stepNum = parseInt(step.getAttribute('data-booking-step'));
      step.hidden = stepNum !== n;
    });

    updateProgress(n);
    updateNavButtons(n);
    updateNavLayout(n);
    hideError();

    if (n === 2) {
      renderServiceSummary();
      renderCalendar();
    }
    if (n === 4) {
      renderSummary();
      els.nextBtn.textContent = state.config.confirmButtonText;
    } else {
      els.nextBtn.textContent = els.nextBtn.getAttribute('data-default-text') || 'Continue';
    }

    // Only scroll to top if the progress bar is above the viewport
    var rect = els.progress.getBoundingClientRect();
    if (rect.top < 0) {
      window.scrollTo({ top: els.progress.offsetTop - 20, behavior: 'smooth' });
    }
  }

  function updateProgress(n) {
    var steps = els.progress.querySelectorAll('[data-progress-step]');
    var lines = els.progress.querySelectorAll('[data-progress-line]');
    var progressStep = state.loggedIn && n === 4 ? 3 : n;

    steps.forEach(function (step) {
      var sn = parseInt(step.getAttribute('data-progress-step'));
      step.classList.remove('saif-booking__progress-step--active', 'saif-booking__progress-step--completed');
      step.removeAttribute('aria-current');
      if (sn === progressStep) {
        step.classList.add('saif-booking__progress-step--active');
        step.setAttribute('aria-current', 'step');
      } else if (sn < progressStep) {
        step.classList.add('saif-booking__progress-step--completed');
      }
    });

    lines.forEach(function (line) {
      var ln = parseInt(line.getAttribute('data-progress-line'));
      line.classList.toggle('saif-booking__progress-line--completed', ln < progressStep);
    });
  }

  function updateNavButtons(n) {
    els.backBtn.hidden = n === 1;

    if (n === 4) {
      els.nextBtn.textContent = state.config.confirmButtonText;
    } else {
      // Restore the default text from the Liquid-rendered button
      els.nextBtn.textContent = els.nextBtn.getAttribute('data-default-text') || 'Continue';
    }

    updateNextButtonState();
  }

  function updateNextButtonState() {
    var n = state.currentStep;
    var enabled = false;

    if (n === 1) {
      enabled = state.selectedService !== null;
    } else if (n === 2) {
      if (state.selectedService && state.selectedService.sessionsCount > 1) {
        enabled = state.selectedSessions.length >= state.selectedService.sessionsCount;
      } else {
        enabled = state.selectedSlot !== null;
      }
    } else if (n === 3 || n === 4) {
      enabled = true;
    }

    els.nextBtn.disabled = !enabled;
  }

  function updateNavLayout(n) {
    // On the single-service step 1 the nav narrows to the card's width
    // so Continue anchors directly under the card instead of floating
    // bottom-right across the empty services grid.
    if (!els.nav) return;
    var single = state.config.services.length === 1;
    els.nav.classList.toggle('saif-booking__nav--under-card', single && n === 1);
  }

  /* ============================================
     SERVICE SELECTION (Step 1)
     ============================================ */
  function bindServiceCards() {
    var cards = document.querySelectorAll('[data-service-block]');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectService(card.getAttribute('data-service-block'));
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectService(card.getAttribute('data-service-block'));
        }
      });
    });
  }

  function selectService(blockId, opts) {
    var service = state.config.services.find(function (s) { return s.id === blockId; });
    if (!service) return;

    var silent = opts && opts.silent;
    if (!silent && window.SaifTrack) window.SaifTrack('booking_service_selected', {
      service_id: service.id,
      service_title: service.title,
      duration_minutes: service.duration,
      sessions_count: service.sessionsCount,
      price: service.price
    });

    state.selectedService = service;
    state.selectedDate = null;
    state.selectedSlot = null;
    state.selectedSessions = [];
    state.availabilityCache = {};

    // Update card selection UI
    document.querySelectorAll('[data-service-block]').forEach(function (card) {
      var isSelected = card.getAttribute('data-service-block') === blockId;
      card.classList.toggle('saif-booking__service-card--selected', isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    updateNextButtonState();
  }

  function renderServiceSummary() {
    if (!state.selectedService) return;
    var s = state.selectedService;
    els.serviceSummary.innerHTML =
      '<div>' +
        '<div class="saif-booking__selected-service-summary-title">' + escapeHtml(s.title) + '</div>' +
        '<div class="saif-booking__selected-service-summary-detail">' +
          s.duration + ' ' + bt('minutes', 'min') + ' · ' + (s.priceFormatted || (state.config.currencySymbol + s.price)) +
          (s.sessionsCount > 1 ? ' · ' + s.sessionsCount + ' ' + bt('sessions', 'sessions') : '') +
        '</div>' +
      '</div>';
  }

  /* ============================================
     CALENDAR (Step 2)
     ============================================ */
  function renderCalendar() {
    var year = state.currentMonth.getFullYear();
    var month = state.currentMonth.getMonth();
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var minDate = getMinBookingDate();
    var maxDate = getMaxBookingDate();
    var availDays = parseAvailableDays();

    var firstDay = new Date(year, month, 1);
    var lastDay = new Date(year, month + 1, 0);
    var startDow = firstDay.getDay();

    var monthNames = MONTHS;
    var dayNames = DAYS;

    var prevDisabled = new Date(year, month, 0) < minDate;
    var nextDisabled = new Date(year, month + 1, 1) > maxDate;

    var html = '<div class="saif-booking__calendar-header">' +
      '<button class="saif-booking__calendar-nav-btn" data-cal-nav="-1"' + (prevDisabled ? ' disabled' : '') + ' aria-label="' + escapeHtml(bt('prev_month', 'Previous month')) + '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<span class="saif-booking__calendar-title">' + monthNames[month] + ' ' + year + '</span>' +
      '<button class="saif-booking__calendar-nav-btn" data-cal-nav="1"' + (nextDisabled ? ' disabled' : '') + ' aria-label="' + escapeHtml(bt('next_month', 'Next month')) + '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>' +
      '</button>' +
    '</div>';

    html += '<div class="saif-booking__calendar-grid">';

    // Day name headers
    for (var d = 0; d < 7; d++) {
      html += '<div class="saif-booking__calendar-day-name">' + dayNames[d] + '</div>';
    }

    // Previous month filler days
    var prevMonthLast = new Date(year, month, 0).getDate();
    for (var i = 0; i < startDow; i++) {
      html += '<div class="saif-booking__calendar-day saif-booking__calendar-day--other-month">' + (prevMonthLast - startDow + 1 + i) + '</div>';
    }

    // Current month days
    var availableDates = [];
    for (var day = 1; day <= lastDay.getDate(); day++) {
      var dateObj = new Date(year, month, day);
      var dateStr = formatDateISO(dateObj);
      var isToday = dateObj.getTime() === today.getTime();
      var dow = dateObj.getDay();
      var inRange = dateObj >= minDate && dateObj <= maxDate;
      var isAvailDay = availDays.indexOf(dow) !== -1;
      var isAvailable = inRange && isAvailDay;
      var isSelected = state.selectedDate === dateStr;

      // Check if this date already has a session booked (for packages)
      var hasSession = state.selectedSessions.some(function (sess) { return sess.date === dateStr; });

      var classes = 'saif-booking__calendar-day';
      if (isToday) classes += ' saif-booking__calendar-day--today';
      if (isAvailable) classes += ' saif-booking__calendar-day--available';
      if (isSelected) classes += ' saif-booking__calendar-day--selected';
      if (!isAvailable) classes += ' saif-booking__calendar-day--disabled';
      if (hasSession) classes += ' saif-booking__calendar-day--has-session';

      if (isAvailable) {
        availableDates.push(dateStr);
        html += '<button class="' + classes + '" data-cal-date="' + dateStr + '" aria-pressed="' + (isSelected ? 'true' : 'false') + '" aria-label="' + monthNames[month] + ' ' + day + '">' + day + '</button>';
      } else {
        html += '<div class="' + classes + '">' + day + '</div>';
      }
    }

    // Next month filler days
    var totalCells = startDow + lastDay.getDate();
    var remaining = totalCells % 7 === 0 ? 0 : 7 - (totalCells % 7);
    for (var r = 1; r <= remaining; r++) {
      html += '<div class="saif-booking__calendar-day saif-booking__calendar-day--other-month">' + r + '</div>';
    }

    html += '</div>';

    els.calendar.innerHTML = html;

    // Bind calendar events
    els.calendar.querySelectorAll('[data-cal-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        navigateMonth(parseInt(btn.getAttribute('data-cal-nav')));
      });
    });

    els.calendar.querySelectorAll('[data-cal-date]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectDate(btn.getAttribute('data-cal-date'));
      });
    });

    // Warm the cache for the earliest available dates so the first slot view
    // isn't a cold app-proxy round-trip (the main source of the "loading takes
    // too long" delay). The cache guard makes repeat renders no-ops.
    if (state.selectedService) {
      availableDates.slice(0, 3).forEach(prefetchAvailability);
    }
  }

  function navigateMonth(delta) {
    var y = state.currentMonth.getFullYear();
    var m = state.currentMonth.getMonth() + delta;
    state.currentMonth = new Date(y, m, 1);
    renderCalendar();
  }

  function selectDate(dateStr) {
    state.selectedDate = dateStr;
    state.selectedSlot = null;
    renderCalendar();

    if (state.availabilityCache[dateStr]) {
      renderSlots(state.availabilityCache[dateStr]);
    } else if (state.prefetching[dateStr]) {
      showSlotsLoading(); // a background prefetch is already in flight; it paints on arrival
    } else {
      fetchAvailability(dateStr);
    }

    updateNextButtonState();
  }

  /* ============================================
     AVAILABILITY API
     ============================================ */
  function fetchAvailability(dateStr) {
    // Availability now comes from the Cloudflare Worker through the storefront
    // App Proxy (same-origin, signed by Shopify) — no API key in page source,
    // no cross-origin call to Google. The Worker computes free slots from the
    // booking working hours minus anything already booked.
    var proxyPath = proxyBase();
    if (!proxyPath) {
      // No proxy configured — fail closed instead of fabricating slots a
      // customer could pay for. Mock slots remain available for design
      // preview behind an explicit ?saif_debug=1 flag only.
      if (/[?&]saif_debug=1/.test(window.location.search)) {
        renderSlots(generateMockSlots());
        return;
      }
      els.slots.innerHTML = '';
      showError('Booking is temporarily unavailable. Please check back soon.');
      els.nextBtn.disabled = true;
      return;
    }

    showSlotsLoading();

    var url = proxyPath + '/bookings/availability' +
      '?date=' + encodeURIComponent(dateStr) +
      '&duration=' + state.selectedService.duration +
      '&buffer=' + (state.selectedService && state.selectedService.buffer != null ? state.selectedService.buffer : state.config.bufferMinutes) +
      '&startHour=' + state.config.dayStartHour +
      '&endHour=' + state.config.dayEndHour +
      '&timezone=' + encodeURIComponent(state.config.timezone);

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.success && data.slots) {
          state.availabilityCache[dateStr] = data.slots;
          // Only render if the user hasn't navigated away
          if (state.selectedDate === dateStr) {
            renderSlots(data.slots);
          }
        } else if (data && data.error === 'INVALID_DATE') {
          renderSlots([]);
        } else {
          // Any other failure (signature, route, server) is an outage, not
          // "no free times" — surface it rather than an empty-slots message.
          if (window.console && console.error) console.error('[saif-booking] availability error:', data && data.error);
          els.slots.innerHTML = '';
          showError((window.SaifI18n && window.SaifI18n.booking_unavailable_error) || 'Booking is temporarily unavailable. Please check back soon.');
          updateNextButtonState();
        }
      })
      .catch(function () {
        /* renderSlots([]) prints "No available times on this date. Please try another day.", which
           reads as Saif being FULLY BOOKED. A failed request is not a full diary. Clear the panel
           instead, exactly as the outage branch above does, and let the error banner speak. */
        showError((window.SaifI18n && window.SaifI18n.availability_check_failed) || 'Could not check availability. Please try again.');
        if (els.slots) els.slots.innerHTML = '';
        updateNextButtonState();
      });
  }

  // Silent background fetch to warm state.availabilityCache so the first time a
  // user opens a date, the slots are already there (the app-proxy round-trip is
  // the slow part — this hides it). No spinner, no error UI; if the user happens
  // to land on the date while it's still loading, the result renders on arrival.
  function prefetchAvailability(dateStr) {
    if (!dateStr || state.availabilityCache[dateStr] || state.prefetching[dateStr] || !state.selectedService) return;
    var proxyPath = proxyBase();
    if (!proxyPath) return;
    state.prefetching[dateStr] = true;
    var url = proxyPath + '/bookings/availability' +
      '?date=' + encodeURIComponent(dateStr) +
      '&duration=' + state.selectedService.duration +
      '&buffer=' + (state.selectedService && state.selectedService.buffer != null ? state.selectedService.buffer : state.config.bufferMinutes) +
      '&startHour=' + state.config.dayStartHour +
      '&endHour=' + state.config.dayEndHour +
      '&timezone=' + encodeURIComponent(state.config.timezone);
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        delete state.prefetching[dateStr];
        if (data && data.success && data.slots) {
          state.availabilityCache[dateStr] = data.slots;
          // If the user is already waiting on this date, paint it now.
          if (state.selectedDate === dateStr) renderSlots(data.slots);
        } else if (state.selectedDate === dateStr) {
          fetchAvailability(dateStr); // prefetch returned nothing usable; do a real fetch (with error UI)
        }
      })
      .catch(function () {
        delete state.prefetching[dateStr];
        if (state.selectedDate === dateStr) fetchAvailability(dateStr);
      });
  }

  function generateMockSlots() {
    var slots = [];
    var start = state.config.dayStartHour;
    var end = state.config.dayEndHour;
    var dur = state.selectedService ? state.selectedService.duration : 60;
    var buf = state.config.bufferMinutes;

    var t = start * 60;
    while (t + dur <= end * 60) {
      var sh = Math.floor(t / 60);
      var sm = t % 60;
      var eh = Math.floor((t + dur) / 60);
      var em = (t + dur) % 60;
      slots.push({
        start: pad(sh) + ':' + pad(sm),
        end: pad(eh) + ':' + pad(em)
      });
      t += dur + buf;
    }
    return slots;
  }

  function showSlotsLoading() {
    els.slots.innerHTML =
      '<div class="saif-booking__slots-loading">' +
        '<div class="saif-booking__spinner"></div>' +
        '<span>' + state.config.loadingText + '</span>' +
      '</div>';
  }

  function renderSlots(slots) {
    if (!state.selectedDate) return;

    // Filter out slots already booked in the selected sessions (for packages)
    var bookedOnDate = state.selectedSessions.filter(function (s) {
      return s.date === state.selectedDate;
    });

    var available = slots.filter(function (slot) {
      return !bookedOnDate.some(function (b) {
        return b.start === slot.start;
      });
    });

    var html = '<div class="saif-booking__slots-heading">' + escapeHtml(bt('available_times', 'Available times')) + '</div>' +
      '<div class="saif-booking__slots-timezone">' + escapeHtml(state.config.timezoneDisplay) + '</div>';

    if (available.length === 0) {
      html += '<div class="saif-booking__slots-empty">' + escapeHtml(state.config.noSlotsText) + '</div>';
    } else {
      html += '<div class="saif-booking__slots-grid">';
      available.forEach(function (slot) {
        var selected = state.selectedSlot && state.selectedSlot.start === slot.start && state.selectedDate === state.selectedSlot.date;
        html += '<button class="saif-booking__slot' + (selected ? ' saif-booking__slot--selected' : '') + '" ' +
          'aria-pressed="' + (selected ? 'true' : 'false') + '" ' +
          'data-slot-start="' + slot.start + '" data-slot-end="' + slot.end + '">' +
          formatTime(slot.start) + ' – ' + formatTime(slot.end) +
        '</button>';
      });
      html += '</div>';
    }

    els.slots.innerHTML = html;

    els.slots.querySelectorAll('.saif-booking__slot').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectSlot({
          date: state.selectedDate,
          start: btn.getAttribute('data-slot-start'),
          end: btn.getAttribute('data-slot-end')
        });
      });
    });
  }

  function selectSlot(slot) {
    var isPackage = state.selectedService && state.selectedService.sessionsCount > 1;

    if (isPackage) {
      addSession(slot);
    } else {
      state.selectedSlot = slot;
      // Toggle selection class without re-rendering (prevents scroll jump)
      els.slots.querySelectorAll('.saif-booking__slot').forEach(function(btn) {
        var on = btn.getAttribute('data-slot-start') === slot.start;
        btn.classList.toggle('saif-booking__slot--selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    updateNextButtonState();
  }

  /* ============================================
     PACKAGE MULTI-SESSION
     ============================================ */
  function getWeekKey(dateStr) {
    // Returns ISO week key (Monday-based) for a date string
    var d = new Date(dateStr + 'T00:00:00');
    var day = d.getDay() || 7; // Make Sunday = 7
    d.setDate(d.getDate() + 4 - day); // Set to Thursday of this week
    var yearStart = new Date(d.getFullYear(), 0, 1);
    var weekNum = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    return d.getFullYear() + '-W' + weekNum;
  }

  function countSessionsInWeek(dateStr) {
    var targetWeek = getWeekKey(dateStr);
    return state.selectedSessions.filter(function(s) {
      return getWeekKey(s.date) === targetWeek;
    }).length;
  }

  function addSession(slot) {
    var max = state.selectedService.sessionsCount;
    if (state.selectedSessions.length >= max) return;

    // Check weekly limit
    var maxPerWeek = state.selectedService.maxPerWeek || 99;
    var inWeek = countSessionsInWeek(slot.date);
    if (inWeek >= maxPerWeek) {
      showError(maxPerWeek === 1
        ? bt('max_per_week_one', 'You can only book 1 session per week. Please choose a different week.')
        : bt('max_per_week_other', 'You can only book {n} sessions per week. Please choose a different week.', { n: maxPerWeek }));
      return;
    }

    state.selectedSessions.push({
      date: slot.date,
      start: slot.start,
      end: slot.end
    });

    renderSelectedSessions();

    // Re-render slots to remove the just-booked one
    if (state.availabilityCache[state.selectedDate]) {
      renderSlots(state.availabilityCache[state.selectedDate]);
    }

    // Re-render calendar to show dot on booked date
    renderCalendar();
    // Re-select the current date visually
    if (state.selectedDate) {
      var dateBtn = els.calendar.querySelector('[data-cal-date="' + state.selectedDate + '"]');
      if (dateBtn) {
        dateBtn.classList.add('saif-booking__calendar-day--selected');
        dateBtn.setAttribute('aria-pressed', 'true');
      }
    }

    updateNextButtonState();
  }

  function removeSession(index) {
    var removed = state.selectedSessions.splice(index, 1)[0];

    // Clear cached availability for that date so it re-fetches
    if (removed) {
      delete state.availabilityCache[removed.date];
    }

    renderSelectedSessions();
    renderCalendar();

    // Re-select the current date if we're looking at one
    if (state.selectedDate) {
      var dateBtn = els.calendar.querySelector('[data-cal-date="' + state.selectedDate + '"]');
      if (dateBtn) {
        dateBtn.classList.add('saif-booking__calendar-day--selected');
        dateBtn.setAttribute('aria-pressed', 'true');
      }
      if (state.availabilityCache[state.selectedDate]) {
        renderSlots(state.availabilityCache[state.selectedDate]);
      }
    }

    updateNextButtonState();
  }

  function renderSelectedSessions() {
    var isPackage = state.selectedService && state.selectedService.sessionsCount > 1;
    if (!isPackage) {
      els.sessions.hidden = true;
      return;
    }

    var max = state.selectedService.sessionsCount;
    var count = state.selectedSessions.length;

    els.sessions.hidden = count === 0;
    els.sessionsCounter.textContent = bt('session_n_of_max', 'Session {n} of {max} selected', { n: count, max: max });

    var html = '';
    state.selectedSessions.forEach(function (sess, i) {
      html += '<li class="saif-booking__session-item">' +
        '<div class="saif-booking__session-info">' +
          '<span class="saif-booking__session-number">' + (i + 1) + '</span>' +
          '<span>' + formatDateHuman(sess.date) + ' · ' + formatTime(sess.start) + ' – ' + formatTime(sess.end) + '</span>' +
        '</div>' +
        '<button class="saif-booking__session-remove" data-remove-session="' + i + '">Remove</button>' +
      '</li>';
    });

    els.sessionsList.innerHTML = html;

    els.sessionsList.querySelectorAll('[data-remove-session]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeSession(parseInt(btn.getAttribute('data-remove-session')));
      });
    });
  }

  /* ============================================
     CUSTOMER FORM (Step 3 — skipped, login via account.saifvoice.com)
     ============================================ */

  function getFormData() {
    var sid = state.config.sectionId;
    var firstName = document.getElementById('SaifBookingFirstName-' + sid);
    var lastName = document.getElementById('SaifBookingLastName-' + sid);
    var email = document.getElementById('SaifBookingEmail-' + sid);
    var phone = document.getElementById('SaifBookingPhone-' + sid);
    var notes = document.getElementById('SaifBookingNotes-' + sid);

    return {
      firstName: firstName ? firstName.value.trim() : state.config.customerFirstName || '',
      lastName: lastName ? lastName.value.trim() : state.config.customerLastName || '',
      email: email ? email.value.trim() : state.config.customerEmail || '',
      phone: phone ? phone.value.trim() : state.config.customerPhone || '',
      notes: notes ? notes.value.trim() : ''
    };
  }

  function validateForm() {
    var data = getFormData();
    if (!data.firstName) {
      showError((window.SaifI18n && window.SaifI18n.error_first_name_required) || 'Please enter your first name.');
      return false;
    }
    if (!data.lastName) {
      showError((window.SaifI18n && window.SaifI18n.error_last_name_required) || 'Please enter your last name.');
      return false;
    }
    if (!data.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      showError((window.SaifI18n && window.SaifI18n.error_invalid_email) || 'Please enter a valid email address.');
      return false;
    }

    return true;
  }

  /* ============================================
     SUMMARY (Step 4)
     ============================================ */
  function renderSummary() {
    var s = state.selectedService;
    var customer = getFormData();
    var isPackage = s.sessionsCount > 1;

    var sessions = isPackage ? state.selectedSessions : [{
      date: state.selectedSlot.date,
      start: state.selectedSlot.start,
      end: state.selectedSlot.end
    }];

    var sessionsHtml = '';
    sessions.forEach(function (sess, i) {
      sessionsHtml += '<li class="saif-booking__summary-session">' +
        (isPackage ? bt('session_n', 'Session {n}', { n: i + 1 }) + ': ' : '') +
        formatDateHuman(sess.date) + ' · ' + formatTime(sess.start) + ' – ' + formatTime(sess.end) +
        ' (' + state.config.timezoneDisplay + ')' +
      '</li>';
    });

    els.summary.innerHTML =
      '<div class="saif-booking__summary-card">' +
        '<div class="saif-booking__summary-section">' +
          '<div class="saif-booking__summary-label">' + escapeHtml(bt('label_service', 'Service')) + '</div>' +
          '<div class="saif-booking__summary-value">' + escapeHtml(s.title) + ' · ' + s.duration + ' ' + escapeHtml(bt('minutes', 'min')) + '</div>' +
        '</div>' +
        '<div class="saif-booking__summary-section">' +
          '<div class="saif-booking__summary-label">' + escapeHtml(isPackage ? bt('label_sessions', 'Sessions') : bt('label_datetime', 'Date & Time')) + '</div>' +
          '<ul class="saif-booking__summary-sessions">' + sessionsHtml + '</ul>' +
        '</div>' +
        '<div class="saif-booking__summary-section">' +
          '<div class="saif-booking__summary-label">' + escapeHtml(bt('label_details', 'Your details')) + '</div>' +
          '<div class="saif-booking__summary-value">' +
            escapeHtml(customer.firstName) + ' ' + escapeHtml(customer.lastName) + '<br>' +
            escapeHtml(customer.email) +
            (customer.phone ? '<br>' + escapeHtml(customer.phone) : '') +
            (customer.notes ? '<br><em>' + escapeHtml(customer.notes) + '</em>' : '') +
          '</div>' +
        '</div>' +
        '<div class="saif-booking__summary-total">' +
          '<span class="saif-booking__summary-total-label" data-saif-total-label>Total</span>' +
          '<span class="saif-booking__summary-total-price" data-saif-total-price>' + (s.priceFormatted || (state.config.currencySymbol + s.price)) + '</span>' +
        '</div>' +
        '<div class="saif-booking__summary-plan-note" data-saif-total-note hidden></div>' +
      '</div>';

    /* SAIF_BUNDLE_V1 — payment plans: reveal THIS service's picker (display is the
       service dimension; the [hidden] attribute stays the geo gate owned by
       saif-plans.js — both must clear for the picker to show). */
    var plansWraps = document.querySelectorAll('[data-saif-booking-plans]');
    Array.prototype.forEach.call(plansWraps, function (w) {
      w.style.display = w.getAttribute('data-saif-plans-service') === String(s.id) ? '' : 'none';
      if (!w.getAttribute('data-saif-total-wired')) {
        w.setAttribute('data-saif-total-wired', '1');
        w.addEventListener('change', updatePlanTotals);
      }
    });
    updatePlanTotals();
  }

  /* SAIF_BUNDLE_V1b — the big Total must never contradict the picker. Reads the active
     service's checked plan radio (data-n/per/total stamped by saif-plan-picker.liquid)
     and rewrites the summary total, adds the schedule note, and swaps the cancellation
     line for its plan-aware twin (plan purchases are final — no refund promise). */
  function updatePlanTotals() {
    var s = state.selectedService;
    if (!s) return;
    var label = document.querySelector('[data-saif-total-label]');
    var price = document.querySelector('[data-saif-total-price]');
    var note = document.querySelector('[data-saif-total-note]');
    var cancelFull = document.querySelector('[data-saif-cancel-full]');
    var cancelPlan = document.querySelector('[data-saif-cancel-plan]');
    if (!label || !price) return;
    var wrap = document.querySelector('[data-saif-booking-plans][data-saif-plans-service="' + String(s.id) + '"]');
    var checked = wrap ? wrap.querySelector('input[type="radio"]:checked') : null;
    var isPlan = !!(checked && checked.value);
    if (isPlan) {
      label.textContent = wrap.getAttribute('data-label-today') || 'Total today';
      price.textContent = checked.getAttribute('data-per') || price.textContent;
      if (note) {
        var tpl = wrap.getAttribute('data-note-tpl') || '%n monthly payments · %t total';
        note.textContent = tpl.replace('%n', checked.getAttribute('data-n') || '').replace('%t', checked.getAttribute('data-total') || '');
        note.hidden = false;
      }
    } else {
      label.textContent = (wrap && wrap.getAttribute('data-label-total')) || 'Total';
      price.textContent = s.priceFormatted || (state.config.currencySymbol + s.price);
      if (note) { note.hidden = true; note.textContent = ''; }
    }
    if (cancelFull) cancelFull.hidden = isPlan;
    if (cancelPlan) cancelPlan.hidden = !isPlan;
  }

  /* ============================================
     BOOKING SUBMISSION
     ============================================ */
  function submitBooking() {
    // Re-entry guard: the loading overlay blocks mouse re-clicks but NOT
    // keyboard activation of the already-focused Confirm button. Without this,
    // holding/double-tapping Enter during the /cart/add.js round-trip fires
    // submitBooking() again, Shopify merges the identical variant into qty 2,
    // and direct checkout double-charges for a single session (pre-launch
    // review #6). Disable the button and flag re-entry until the request settles.
    if (state.submitting) return;
    state.submitting = true;
    if (els.nextBtn) els.nextBtn.disabled = true;

    var s = state.selectedService;
    var customer = getFormData();
    var isPackage = s.sessionsCount > 1;

    /* Belt: if the slot state was ever lost (the data-service-block collision once
       nulled it from inside the plan picker), fail soft instead of throwing after
       the button is already disabled — a throw here bricks the whole step. */
    if (isPackage ? !(state.selectedSessions && state.selectedSessions.length) : !state.selectedSlot) {
      state.submitting = false;
      if (els.nextBtn) els.nextBtn.disabled = false;
      showError('Your time slot needs re-picking — please go back one step and choose it again.');
      return;
    }

    var sessions = isPackage ? state.selectedSessions : [{
      date: state.selectedSlot.date,
      start: state.selectedSlot.start,
      end: state.selectedSlot.end
    }];

    if (window.SaifTrack) window.SaifTrack('booking_submitted', {
      service_id: s.id,
      service_title: s.title,
      duration_minutes: s.duration,
      sessions_count: sessions.length,
      price: s.price,
      first_session_date: sessions[0] && sessions[0].date
    });

    showOverlay(true);

    // Booking is no longer created up-front. The full booking payload travels
    // along the cart as a hidden line-item property; the Cloudflare Worker's
    // /webhooks/orders-paid handler unpacks it and creates the calendar event
    // only after Shopify confirms the order is paid. Prevents abandoned carts
    // from holding instructor time slots.
    addToShopifyCart(sessions, customer)
      .then(function (response) {
        if (state.config.checkoutMode === 'direct') {
          // Keep the page LOCKED right up to navigation — do not clear the
          // submit guard, re-enable Continue, or drop the overlay, so a
          // double-tap can't fire a second checkout while we redirect.
          window.location.href = '/checkout';
          return;
        }
        // Go to the cart PAGE (owner, 2026-08-02: "in the booking page it sends me to
        // shop automatically when it should send to cart instead"). This used to open
        // the theme's corner cart-notification instead, on the reasoning that a booking
        // should feel like adding any other product. It shouldn't: the shopper has just
        // finished a multi-step wizard and needs to see the date, time and timezone they
        // picked read back to them, which the popup does not show. Keep the page locked
        // right up to navigation so a double-tap cannot fire a second add.
        window.location.href = '/cart';
      })
      .catch(function (err) {
        state.submitting = false;
        if (els.nextBtn) els.nextBtn.disabled = false;
        showOverlay(false);
        /* SAIF_BOOKING_ERRTEXT_V1 (2026-08-04) — this used to print err.message unconditionally,
           so when the cart replied with HTML instead of JSON (a Cloudflare challenge, an outage,
           a captive-portal wifi page) the buyer read, at the pay moment on a $172-$688 purchase:
             Unexpected token '<', "<!DOCTYPE "... is not valid JSON
           Hit for real during the 2026-08 audit. Only OUR OWN messages are shown now; anything
           thrown by fetch or JSON.parse falls back to the friendly line. saifFriendly is set by
           fail() below, which is the only thing allowed to reach the customer. */
        showError((err && err.saifFriendly && err.message) || (window.SaifI18n && window.SaifI18n.error_generic) || 'Something went wrong. Please try again.');
      });
  }

  /* An error whose text is safe to show a customer. Anything without this flag is a raw
     runtime message and is swallowed in favour of SaifI18n.error_generic. */
  function fail(msg) {
    var e = new Error(msg || (window.SaifI18n && window.SaifI18n.error_generic) || 'Something went wrong. Please try again.');
    e.saifFriendly = true;
    return e;
  }

  /* Read a fetch Response as JSON, but check it SUCCEEDED first. r.json() on an HTML error page
     throws a parser message, and that message used to be what the buyer saw. */
  function okJson(r) {
    if (!r.ok) throw fail((window.SaifI18n && window.SaifI18n.error_generic) || 'Something went wrong. Please try again.');
    return r.json().catch(function () {
      throw fail((window.SaifI18n && window.SaifI18n.error_generic) || 'Something went wrong. Please try again.');
    });
  }

  function addToShopifyCart(sessions, customer) {
    var s = state.selectedService;

    // Resolve the numeric variant id (look it up by handle if the service
    // block didn't hard-code one).
    var resolveVariant = s.variantId
      ? Promise.resolve(parseInt(s.variantId, 10))
      : fetch('/products/' + s.productHandle + '.js')
          .then(okJson)
          .then(function (product) { return product.variants[0].id; });

    return resolveVariant.then(function (vid) {
      // Remove only a TRUE duplicate: same service AND the same booked slot. Every
      // session of a service shares ONE variant id — the date/time lives only in the
      // line-item properties — so matching on variant_id alone silently deleted a
      // customer's earlier, legitimate lesson when they came back and booked a second
      // one. Two different slots are two real lessons: keep both (they are visible in
      // the cart and removable). An identical re-book still collapses to one line.
      //
      // Compare _booking_data (raw dates/times) rather than the Schedule sentence:
      // that sentence is display copy built from English month names and AM/PM, so
      // translating it — or changing the date format — would silently break this
      // guard and double-book the customer.
      var newSlots = slotKey(sessions);
      return fetch('/cart.js')
        .then(okJson)
        .then(function (cart) {
          var priorKeys = (cart.items || [])
            .filter(function (it) {
              if (it.variant_id !== vid) return false;
              var raw = it.properties && it.properties._booking_data;
              if (!raw) return false;
              try {
                return slotKey(JSON.parse(raw).sessions) === newSlots;
              } catch (e) {
                return false; // unparseable line: leave it alone rather than delete it
              }
            })
            .map(function (it) { return it.key; });
          var chain = Promise.resolve();
          priorKeys.forEach(function (key) {
            chain = chain.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
              });
            });
          });
          return chain.then(function () { return postToCart(vid, sessions, customer); });
        });
    });
  }

  // A stable identity for a set of booked slots, built from RAW date/time values —
  // never from display copy. buildScheduleString() below renders the human sentence
  // via formatDateHuman()/formatTime(), which carry English month names and AM/PM;
  // comparing THAT would break the duplicate guard the moment the copy is translated
  // or the date format is tweaked, and a broken guard means a double booking.
  // Sorted so slot order can't create a false mismatch.
  function slotKey(sessions) {
    return (sessions || [])
      .map(function (s) { return String(s.date) + 'T' + String(s.start) + '-' + String(s.end); })
      .sort()
      .join('|');
  }

  // The booked slot(s) rendered exactly as they land on the cart line's Schedule
  // property. DISPLAY ONLY — never compare against this (see slotKey above).
  function buildScheduleString(sessions) {
    return sessions.map(function (s, i) {
      return (sessions.length > 1 ? bt('session_n', 'Session {n}', { n: i + 1 }) + ': ' : '') +
        formatDateHuman(s.date) + ' ' + formatTime(s.start) + '-' + formatTime(s.end);
    }).join('; ');
  }

  function postToCart(variantId, sessions, customer) {
    var sessionsStr = buildScheduleString(sessions);

    // Human-readable properties show on the order confirmation; underscored
    // properties stay hidden from the customer but are still readable by the
    // /webhooks/orders-paid handler in the Worker.
    var properties = {
      'Service': state.selectedService.title,
      'Schedule': sessionsStr,
      'Timezone': state.config.timezoneDisplay,
      '_customer_name': customer.firstName + ' ' + customer.lastName,
      '_customer_email': customer.email
    };
    if (customer.phone) properties['_customer_phone'] = customer.phone;
    if (customer.notes) properties['Notes'] = customer.notes;

    // Machine-readable payload the orders/paid webhook unpacks to call
    // Apps Script's createBooking. Single JSON blob keeps this resilient
    // to future field additions without changing the worker's parser.
    properties['_booking_data'] = JSON.stringify({
      service: state.selectedService.title,
      duration: state.selectedService.duration,
      sessions: sessions,
      customer: {
        firstName: customer.firstName,
        lastName: customer.lastName,
        email: customer.email,
        phone: customer.phone || '',
        notes: customer.notes || ''
      },
      timezone: state.config.timezone,
      timezoneDisplay: state.config.timezoneDisplay
    });

    var body = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: properties
      }]
    };
    /* SAIF_BUNDLE_V1 — carry the chosen payment plan into the cart. The picker only
       exists (and is only visible) for plan-carrying services in allowed regions, so a
       missing/unchecked picker simply means pay-in-full. */
    var planWrap = document.querySelector('[data-saif-booking-plans][data-saif-plans-service="' + String(state.selectedService.id) + '"]');
    var planChecked = planWrap ? planWrap.querySelector('input:checked') : null;
    if (planChecked && planChecked.value) {
      body.items[0].selling_plan = parseInt(planChecked.value, 10);
    }
    // Ask Shopify to return the cart-drawer section HTML in the response so the
    // drawer can render + open without a second round-trip (Dawn cart pattern).
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw fail('Could not add to cart. Please check that the product is set up correctly.');
      return r.json();
    });
  }

  /* ============================================
     NAV BUTTONS
     ============================================ */
  function bindNavButtons() {
    // Save default text
    els.nextBtn.setAttribute('data-default-text', els.nextBtn.textContent.trim());

    els.nextBtn.addEventListener('click', function () {
      if (els.nextBtn.disabled) return;

      if (state.currentStep === 4) {
        submitBooking();
        return;
      }

      var nextStep = state.loggedIn && state.currentStep === 2 ? 4 : state.currentStep + 1;

      // Validate step 3 form before proceeding to step 4
      if (state.currentStep === 3) {
        var formValid = validateForm();
        if (!formValid) return;
      }

      if (nextStep <= 4) {
        goToStep(nextStep);
      }
    });

    els.backBtn.addEventListener('click', function () {
      var prevStep = state.loggedIn && state.currentStep === 4 ? 2 : state.currentStep - 1;

      if (prevStep >= 1) {
        goToStep(prevStep);
      }
    });
  }

  /* ============================================
     UI HELPERS
     ============================================ */
  function showError(msg) {
    els.error.textContent = msg;
    els.error.hidden = false;
    window.scrollTo({ top: els.error.offsetTop - 20, behavior: 'smooth' });
  }

  function hideError() {
    els.error.hidden = true;
    els.error.textContent = '';
  }

  function showOverlay(show) {
    els.overlay.hidden = !show;
  }

  /* ============================================
     DATE/TIME UTILITIES
     ============================================ */
  function getMinBookingDate() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + (state.config ? state.config.advanceDaysMin : 1));
    // A fixed cut-off ("earliest bookable date") wins whenever it is LATER than
    // the rolling notice period, so both settings can coexist: the notice period
    // keeps applying normally, and the cut-off simply stops being the binding
    // constraint once it has passed. Parsed as LOCAL midnight — new Date('...')
    // on a bare YYYY-MM-DD is parsed as UTC, which lands a day early for anyone
    // west of Greenwich.
    var fixed = state.config && state.config.earliestDate;
    if (fixed && /^\d{4}-\d{2}-\d{2}$/.test(fixed)) {
      var p = fixed.split('-');
      var f = new Date(+p[0], +p[1] - 1, +p[2]);
      f.setHours(0, 0, 0, 0);
      if (!isNaN(f.getTime()) && f > d) return f;
    }
    return d;
  }

  function getMaxBookingDate() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + (state.config ? state.config.advanceDaysMax : 28));
    return d;
  }

  function parseAvailableDays() {
    if (!state.config || !state.config.availableDays) return [1, 2, 3, 4, 5];
    // "1,2,3,4,5" is machine data in a text setting, and Translate & Adapt rewrites text
    // settings: on /ar it came back as "1،2،3،4،5" with ARABIC commas. Splitting on "," alone
    // left one token, parseInt read 1, and the Arabic calendar offered Mondays and nothing else
    // — ten of the thirteen bookable days in the month silently disappeared. Accept either
    // comma, and normalise Arabic-Indic digits, so a translated separator cannot close the diary.
    var days = String(state.config.availableDays)
      .replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); })
      .replace(/[۰-۹]/g, function (d) { return String(d.charCodeAt(0) - 0x06F0); })
      .split(/[,،؛;]+/)
      .map(function (d) { return parseInt(d.trim(), 10); })
      .filter(function (d) { return d >= 0 && d <= 6; });
    return days.length ? days : [1, 2, 3, 4, 5];
  }

  function formatDateISO(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function formatDateHuman(dateStr) {
    var parts = dateStr.split('-');
    var d = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    /* Swapping the month and weekday NAMES for Arabic left the date in English GRAMMAR —
       "الجمعة, أغسطس 14, 2026" instead of "الجمعة، 14 أغسطس 2026". Intl knows the order for each
       locale, so let it assemble the whole date rather than only its words.

       Latin digits are forced (-u-nu-latn) because every other number on the page — prices, times,
       counters — is Latin, and one date in Arabic-Indic numerals would read as a different system.

       English keeps the original hand-built shape byte for byte; this branch never runs for it. */
    if (!/^en/i.test(DOC_LANG)) {
      try {
        var loc = DOC_LANG + (/^ar/i.test(DOC_LANG) ? '-u-nu-latn' : '');
        return new Intl.DateTimeFormat(loc, {
          weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
        }).format(d);
      } catch (e) { /* fall through to the English shape */ }
    }
    var months = MONTHS_SHORT;
    var days = DAYS;
    return days[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  function formatTime(timeStr) {
    var parts = timeStr.split(':');
    var h = parseInt(parts[0]);
    var m = parts[1];
    var ampm = h >= 12 ? bt('pm', 'PM') : bt('am', 'AM');
    h = h % 12 || 12;
    return h + ':' + m + ' ' + ampm;
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ============================================
     SHOPIFY DESIGN MODE
     ============================================ */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('[id^="SaifBookingConfig-"]')) {
        init();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
